/**
 * @author Zdenka Valkučáková <zdenka.valkucakova@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ErrorName from '../error/error-name';

/**
 * Chyba vyskytující se při registraci zařízení na serveru.
 */
export default class SetupError extends Error {
  /**
   * @param {string} [message] Popis chyby.
   * @param {Object} [options = {}]
   * @param {unknown} [options.cause] Příčina chyby.
   * @param {Response} [options.response] Případná odpověď serveru,
   * pokud byl požadavek vyřešen z pohledu Fetch API.
   */
  constructor(message, { cause, response } = {}) {
    super(message, { cause });
    this.name = ErrorName.SetupError;
    this.response = response;

    // TODO: Odkomentovať, ak je potrebné definovať nové metódy.
    // Vlastní nastavení prototypu.
    // Nezabudnúť to manuálne nastaviť aj pre každú podtriedu.
    // - https://www.typescriptlang.org/docs/handbook/2/classes.html#inheriting-built-in-types
    // Object.setPrototypeOf(this, SetupError.prototype);
  }
}
